<template>
  <div class="text-gray-900 sm:truncate md:text-2xl">
    <slot />
  </div>
</template>
